import { minutesToMilliseconds } from "date-fns";

import { getCompanyAISettings } from "../../services/defs/internal-api/ai";

export const companyAISettingsQuery = () => ({
	queryKey: ["ai", "settings"],
	queryFn: () => getCompanyAISettings(),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting the company settings.",
	},
});
